class PlaceholderParametersGenerator {
  static createHasOneRelationParameters(relation) {
    return {
      type: "hasOne",
      field: relation.field,
      filter: relation.filter,
      reducedBy: relation.reducedBy
    };
  }
  static createHasManyRelationParameters(relation) {
    return {
      type: "hasMany",
      field: relation.field,
      filter: relation.filter,
      offset: relation.offset,
      limit: relation.limit,
      orderBy: relation.orderBy
    };
  }
  static createEntityListSubTreeParameters(parameters, environment) {
    if (parameters.isCreating) {
      return {
        type: "entityListSubtree",
        isCreating: true,
        entityName: parameters.entityName,
        variables: environment.getAllVariables()
      };
    }
    return {
      type: "entityListSubtree",
      isCreating: false,
      entityName: parameters.entityName,
      filter: parameters.filter,
      offset: parameters.offset,
      limit: parameters.limit,
      orderBy: parameters.orderBy,
      variables: environment.getAllVariables()
    };
  }
  static createEntitySubTreeParameters(parameters, environment) {
    if (parameters.isCreating) {
      return {
        type: "entitySubTree",
        isCreating: true,
        entityName: parameters.entityName,
        variables: environment.getAllVariables()
      };
    }
    return {
      type: "entitySubTree",
      isCreating: false,
      where: parameters.where,
      entityName: parameters.entityName,
      filter: parameters.filter,
      variables: environment.getAllVariables()
    };
  }
}
export {
  PlaceholderParametersGenerator
};
//# sourceMappingURL=PlaceholderParametersGenerator.js.map
